import qs from 'qs';

const DOMAIN_MAP = {
  S1: 'https://mc.exacttarget.com',
  S5: 'https://mc.boa.exacttarget.com'
};

export default function getStackUrl() {
  const stackKey = qs.parse(window.location.search.substr(1)).stackKey;
  let stackUrl = DOMAIN_MAP[stackKey];
  if (!stackUrl && stackKey) {
    const mcProdRegex = /^s\d{1,3}$/i;
    const hyperforceQaRegex = /^(?:test2|stage3|dev(?:\ds)?1)[0-9][0-9]$/gi;
    let stackNum = parseInt(stackKey);
    if (mcProdRegex.test(stackKey)) {
      stackUrl = `https://mc.${stackKey.toLowerCase()}.exacttarget.com`;
    } else if (hyperforceQaRegex.test(stackKey)) {
      stackNum = stackKey.substring(hyperforceQaRegex.lastIndex - 3);
      if (stackNum >= 100 && stackNum < 200) {
        // 100-199 dev
        stackUrl = `https://mc.${stackNum}.dev.exacttarget.com`;
      } else if (stackNum < 300) {
        // 200-299 test
        stackUrl = `https://mc.${stackNum}.test.exacttarget.com`;
      } else if (stackNum < 400) {
        // 300-399 stage
        stackUrl = `https://mc.${stackNum}.stage.exacttarget.com`;
      }
    } else if (!isNaN(stackNum)) {
      if (stackNum < 500) {
        // 400-499 prod
        stackUrl = `https://mc.${stackKey}.exacttarget.com`;
      } // else unknown
    } else {
      const mcQaRegex = /^QA(\d)S(\d)$/i;
      const match = stackKey.match(mcQaRegex);
      if (match) {
        const s = match[2];
        const qa = match[1];
        stackUrl = `https://mc.s${s}.qa${qa}.exacttarget.com`;
      }
    }
  }
  return stackUrl;
}
